/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-square-email': {
    width: 43.411,
    height: 43.411,
    viewBox: '0 0 43.411 43.411',
    data:
      '<g data-name="Group 1556"><path pid="0" data-name="Path 420" d="M5.866 0h31.679a5.867 5.867 0 0 1 5.866 5.866v31.679a5.866 5.866 0 0 1-5.866 5.866H5.866A5.865 5.865 0 0 1 0 37.545V5.864A5.866 5.866 0 0 1 5.866-.002" _fill="gray"/><path pid="1" data-name="Path 421" d="M30.971 11.732H12.053a3.844 3.844 0 0 0-3.84 3.841v13.214a3.845 3.845 0 0 0 3.84 3.84h18.919a3.845 3.845 0 0 0 3.84-3.84V15.576a3.845 3.845 0 0 0-3.841-3.841m0 1.837a2.006 2.006 0 0 1 .456.053l-7.978 9.051a2.58 2.58 0 0 1-3.643.229 2.679 2.679 0 0 1-.229-.229l-7.978-9.057a2 2 0 0 1 .455-.053zm2.005 15.218a2.008 2.008 0 0 1-2 2H12.053a2.007 2.007 0 0 1-2-2V15.576a2 2 0 0 1 .151-.761l8 9.08a4.413 4.413 0 0 0 6.622 0l8-9.078a1.979 1.979 0 0 1 .15.759z" _fill="#fff"/></g>'
  }
})
